import { render, staticRenderFns } from "./ScreenMain.vue?vue&type=template&id=10ee60c2&scoped=true"
import script from "./ScreenMain.vue?vue&type=script&lang=js"
export * from "./ScreenMain.vue?vue&type=script&lang=js"
import style0 from "./ScreenMain.vue?vue&type=style&index=0&id=10ee60c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee60c2",
  null
  
)

export default component.exports